import { SVGProps } from 'react';
import SVG from '.';
import { SVGIconArrowDown } from './SVGIconArrowDown';
import { SVGIconArrowUp } from './SVGIconArrowUp';

export default Object.assign(
  ({ children, width = 20, height = 20, color, ...rest }: SVGProps<any>) => {
    return <SVG {...rest}>{children}</SVG>;
  },
  {
    Down: SVGIconArrowDown,
    Up: SVGIconArrowUp,
  },
);
